import moment from "moment";

function getMonthShortName(monthNo: number) {
  const date = new Date();
  date.setMonth(monthNo);

  return date.toLocaleString('en-US', { month: 'short' });
}

/** Returns:
  {
    raw: new Date(strDate),
    date: 'Oct 10, 2018',
    time: '20:34:02',
    dateTime: 'Oct 10, 2018 20:34:02',
    fromNow: '2 hours ago'
  }
*/
export const formattedDate = (strDate: string) => {
  const date = new Date(strDate);

  const day   = date.getDate();
  const month = getMonthShortName(date.getMonth());
  const year  = date.getFullYear();

  const hours   = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();

  return {
    raw: date,
    date: `${month} ${day}, ${year}`,
    time: `${hours}:${minutes}:${seconds}`,
    dateTime: `${month} ${day}, ${year} ${hours}:${minutes}:${seconds}`,
    fromNow: moment(date).fromNow()
  }
}

/** Returns a new date with the added days */
export const addDays = (days: number, date?: Date) => {
  const result = new Date(date || new Date());
  result.setDate(result.getDate() + days);

  return result;
}

export const addYears = (years: number, date?: Date) => {
  const result = new Date(date || new Date());
  result.setFullYear(result.getFullYear() + years);

  return result;
}
